'use client';
import {useTranslation} from 'react-i18next';
import {trackHomepageCardClick, trackHomepageViewAllClick} from '../../analytics';
import {LATEST_NEWS_EMPTY} from '../../content';
import {localeHref, useLocale} from '../../i18n';
import type {NewsCardView} from '../../model';
import {CarouselSection} from './CarouselSection';
import {ListingCard} from './ListingCard';
import {newsCardProps} from './newsCard';

// Fixed news-card media size in px (Figma 24-6871); hoisted past the i18n lint rule.
const NEWS_MEDIA_SIZE = '364 / 360';
const SECTION_NAME = 'latest_news';

export interface LatestNewsCarouselProps {
  articles: NewsCardView[];
  title?: string;
  sectionId?: string;
}

export function LatestNewsCarousel({articles, title, sectionId}: LatestNewsCarouselProps) {
  const {t} = useTranslation();
  const locale = useLocale();
  const newsHref = localeHref(locale, '/news');
  const section = {name: SECTION_NAME, id: sectionId};

  return (
    <CarouselSection
      title={title ?? t('latest_news_title')}
      subtitle={t('latest_news_subtitle')}
      titleMobileSize="title-5"
      empty={LATEST_NEWS_EMPTY}
      viewAll={{
        label: t('view_all_news'),
        href: newsHref,
        onClick: () => {
          trackHomepageViewAllClick(section);
        },
      }}
    >
      {articles.map(article => (
        <ListingCard
          deferImage
          key={article.uuid}
          {...newsCardProps(article, locale)}
          aspectRatio={NEWS_MEDIA_SIZE}
          fixedMedia
          onClick={() => {
            trackHomepageCardClick({id: article.uuid, name: article.title}, section);
          }}
        />
      ))}
    </CarouselSection>
  );
}

LatestNewsCarousel.displayName = 'LatestNewsCarousel';
